import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Header from "../../components/header/Header";

const Unsubscribe = () => {
  const { code } = useParams();
  const { title } = useParams();

  if (
    title === "Support member" ||
    title === "Support member - Daily Activities Reminder" ||
    title === "Support member - Daily Progress Reminder" ||
    title === "Support member - End Of Week Progress"
  ) {
    axios
      .post(window.ajaxLink + "user/unsubscribeCommunity", { param: code })
      .then((res) => {
        if (res.data.responseData) {
          //console.log(">>>>", res.data.responseData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  } else {
    axios
      .post(window.ajaxLink + "user/unsubscribe", { param: code })
      .then((res) => {
        if (res.data.responseData) {
          //console.log(">>>>", res.data.responseData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  return (
    <div>
      <Header></Header>
      <div style={{ textAlign: "center", marginTop: "70px", fontSize: "24px" }}>
        You have successfully unsubscribed from our daily and weekly e-mail list.
      </div>
    </div>
  );
};

export default Unsubscribe;
